import styled from 'styled-components';
import Button from '@mui/material/Button';

export const StyledButton = styled(Button)<{ width?: string; $maxWidth?: string }>`
  width: ${({ width }) => width ?? '209px'};
  max-width: ${({ $maxWidth }) => $maxWidth};
  height: 31px;
  font-weight: 600;
  font-size: 12px;
`;
